import type {EffectiveEntryStatus} from '../../../helpers/effective-entry-status'
import {AfterStatusLabel} from './effective-entry-status-labels/AfterStatusLabel'
import {BlockedDownstackStatusLabel} from './effective-entry-status-labels/BlockedDownstackStatusLabel'
import {ClosedStatusLabel} from './effective-entry-status-labels/ClosedStatusLabel'
import {DraftStatusLabel} from './effective-entry-status-labels/DraftStatusLabel'
import {LoadingStatusLabel} from './effective-entry-status-labels/LoadingStatusLabel'
import {MergedStatusLabel} from './effective-entry-status-labels/MergedStatusLabel'
import {MergingStatusLabel} from './effective-entry-status-labels/MergingStatusLabel'
import {NotReadyStatusLabel} from './effective-entry-status-labels/NotReadyStatusLabel'
import {QueuedStatusLabel} from './effective-entry-status-labels/QueuedStatusLabel'
import {ReadyStatusLabel} from './effective-entry-status-labels/ReadyStatusLabel'

export function EffectiveEntryStatusLabel(props: {status: EffectiveEntryStatus}) {
  return (
    <>
      <AfterStatusLabel {...props} />
      <BlockedDownstackStatusLabel {...props} />
      <ClosedStatusLabel {...props} />
      <DraftStatusLabel {...props} />
      <LoadingStatusLabel {...props} />
      <MergedStatusLabel {...props} />
      <MergingStatusLabel {...props} />
      <NotReadyStatusLabel {...props} />
      <QueuedStatusLabel {...props} />
      <ReadyStatusLabel {...props} />
    </>
  )
}
